module.exports = __webpack_public_path__ + "img/icon_pencil.4b8271b1.svg";